<template>
    <main>
        <div class="sharethis-sticky-share-buttons" v-bind:data-url="txtShareURL"></div>

        <div id="hello-vue" class="demo">

            <div v-show="loading">

                <div class="container text-center loading-data">
                    <div class="loading-content">
                        <i class="fas fa-bahai mb15 fa-spin" aria-hidden="true"></i>
                        <span>Data loading</span>
                    </div>
                </div>
            </div>

            <div v-show="!loading">
                <a href="#" class="back-to-top"><i class="fas fa-caret-up"></i>Back to top</a>
                
                <div class="container-fluid main-section filters-section">

                    <div class="filter-top-tab">
                        <span>What would you like to find out?</span>
                        <p>Select from the categories immediately below to filter the Natsal results in the outputs on this page. You can select one or more categories and reset your filters by pressing ‘reset’.</p>
                        <a id="mob-filter-button" onclick="showFilters()" class="btn btn-primary"><i class="fa fa-filter"></i>Show filters</a>
                    </div>
               
                    <div class="filter-wrapper ">

                        <div class="filter-header">
                            <a id="mob-filter-button-close" onclick="showFilters()" class="btn btn-danger" aria-label="Close"><i class="fa fa-times"></i></a>
                            <h3 class="filter-title">Filters</h3>
                        </div>

                        <div class="filter-wrapper-inner">

                            <div class="row row-cols-5">

                                <div class="col filter-1">

                                    <div class="filter-inner">
                                        
                                        <h3>Sex</h3>

                                        <div class="row row-cols-2">

                                            <div class="col text-center">

                                                <div class="filter-option female" v-on:click="ChangeFilter('gender','female')" v-bind:class="{ active: filters.gender.female}">
                                                    <i class="fas fa-venus"></i>
                                                    <span>Female</span>
                                                </div>

                                            </div>

                                            <div class="col text-center">

                                                <div class="filter-option male" v-on:click="ChangeFilter('gender','male')" v-bind:class="{ active: filters.gender.male }">
                                                    <i class="fas fa-mars"></i>
                                                    <span>Male</span>
                                                </div>

                                            </div>
                                            

                                        </div>

                                    </div>

                                </div>

                                <div class="col filter-2">

                                    <div class="filter-inner">

                                        <h3>Age group</h3>

                                        <div class="row row-cols-1">

                                            <div class="col">
                                                <span v-on:click="ChangeFilter('ageGroup','young')" v-bind:class="{ active: filters.ageGroup.young }">16-29</span>
                                            </div>

                                            <div class="col">
                                                <span v-on:click="ChangeFilter('ageGroup','middle')" v-bind:class="{ active: filters.ageGroup.middle }">30-49</span>
                                            </div>

                                            <div class="col">
                                                <span v-on:click="ChangeFilter('ageGroup','older')" v-bind:class="{ active: filters.ageGroup.older }">50+</span>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <div class="col filter-3">

                                    <div class="filter-inner">

                                        <h3>Living with partner</h3>

                                        <div class="row">

                                            <div class="col text-right">

                                                <span v-on:click="ChangeFilter('livingWithPartner','Yes')" v-bind:class="{ active: filters.livingWithPartner.Yes }">Yes</span>
                                            </div>

                                            <div class="col text-left">

                                                <span v-on:click="ChangeFilter('livingWithPartner','No')" v-bind:class="{ active: filters.livingWithPartner.No }">No</span>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <div class="col filter-4">

                                    <div class="filter-inner">

                                        <h3>Sexual identity</h3>
                                        <p class="small">Response options were limited to 'gay/lesbian', 'bisexual' and 'other'</p>

                                        <div class="filter-options">

                                            <div class="col">
                                                <span v-on:click="ChangeFilter('sexuality', 'hetero')" v-bind:class="{ active: filters.sexuality.hetero }">Heterosexual</span>
                                            </div>

                                            <div class="col">
                                                <span v-on:click="ChangeFilter('sexuality', 'nonhetero')" v-bind:class="{ active: filters.sexuality.nonhetero }">LGBTQ+</span>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <div class="col filter-5">

                                    <div class="filter-inner">

                                        <h3>Parenting</h3>
                                        <p class="small">Including adopted, step, fostered, son and daughter</p>

                                        <div class="row row-cols-1">

                                            <div class="col">
                                                <span v-on:click="ChangeFilter('parenting','nochildren')" v-bind:class="{ active: filters.parenting.nochildren }">No children</span>
                                            </div>

                                            <div class="col">
                                                <span v-on:click="ChangeFilter('parenting','child0to17')" v-bind:class="{ active: filters.parenting.child0to17 }">Children under 18 years old</span>
                                            </div>
                                            
                                            <div class="col">
                                                <span v-on:click="ChangeFilter('parenting','child18plus')" v-bind:class="{ active: filters.parenting.child18plus }">Children aged 18 and older</span>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                        <div class="blurred-box"></div>
                            
                        <!-- <div v-show="!this.allNotSelected">
                            <span v-on:click="ShowShareLink = !ShowShareLink">SHARE LINK</span><br />
                            <input type="text" disabled="true" class="form-control" v-model="txtShareURL" v-show="ShowShareLink" />
                        </div> -->
                    </div>

                    <div class="filter-bottom-tab">
                        <span>{{itemsFiltered.length.toLocaleString()}} matching results</span>
                        <a href="#" class="btn btn-grey btn-sm" v-on:click="ResetFilters()">Reset filters</a>
                    </div>
                </div>

                <div class="container">

                    <div class="graph-panel" data-height="height" v-show="itemsFiltered.length < 30">

                        <div class="box-inner">

                            <div class="row">

                                <div class="col-sm-12 text-center">
                                    <h3>The results are unlikely to be very reliable when there are fewer than 30 participants in a filter and so search results are not displayed for this query.</h3>
                                    
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

                <div class="container-fluid main-section graph-section" data-auto-height="true" v-show="itemsFiltered.length >= 30">

                    <div class="row">

                        <natsal-chart title="How old are people in Britain when they first have sex?" 
                                    description="<h5>What does this chart show?</h5><p>This chart shows the distribution of age at first sex among people living in Britain aged 16 to 74 as estimated from Natsal-3, taking the younger age reported by Natsal-3 participants to the following two questions.</p><strong>Which Natsal-3 questions does it relate to?</strong><br/>
                                    <p>How old were you when you first had sexual intercourse with someone of the opposite sex, or hasn't this happened?<br/>How old were you the first time you had sex with a man* involving (genital area vaginal/penis) contact?</p>
                                    <p>* if the participant is a man, else 'woman' if the participant is a woman.</p>"
                                    chartId="age-first-sex-comp"
                                    :originalData="originalDataSets.sexualDebutData"
                                    :filteredData="filteredDataSets.sexualDebutData"
                                    :categories="['13-15', '16-17', '18-19', '20+', ['Not had', 'sex yet']]"
                                    graphModalId="#graph1modal"
                                    :originalDataCount="originalDataCount"
                                    hasMedian="false"
                                    :noAnswer="noAnswerTotals.AgeFirstSex"
                                    :noAnswerFiltered="noAnswerTotals.AgeFirstSexFiltered"
                                    xAxisTitle="Age at first sex"></natsal-chart>

                        <natsal-chart title="How many sexual partners do people in Britain have?" 
                                    description="<h5>What does this chart show?</h5><p>This chart shows the distribution of numbers of sexual partners over the lifetime for people living in Britain aged 16 to 74 as estimated from Natsal-3. It combines responses from the following two questions.</p><strong>Which Natsal-3 questions does it relate to?</strong><br/>
                                    <p>Altogether, in your life so far, how many women* have you had sexual intercourse with (vaginal, oral or anal)?<br/>Altogether, in your life so far, how many men** have you had sex with (that is oral, anal sex or other forms of genital contact)?</p>
                                    <p>* if the participant is a man, else 'men' if the participant is a woman.<br/>** if the participant is a man, else 'women' if the participant is a woman.</p>"
                                    chartId="sexual-partners-comp"
                                    :originalData="originalDataSets.sexualPartnersData"
                                    :filteredData="filteredDataSets.sexualPartnersData"
                                    :categories="['0', '1', '2-4', '5-9', '10+']"
                                    graphModalId="#graph2modal"
                                    :originalDataCount="originalDataCount"
                                    hasMedian="true"
                                    :noAnswer="noAnswerTotals.TotalPartners"
                                    :noAnswerFiltered="noAnswerTotals.TotalPartnersFiltered"
                                    xAxisTitle="Number of partners by the time of the interview"
                                    :customMedianIQR="customMedianIQR.TotalPartners"
                                    :customMedianIQRFiltered="customMedianIQR.TotalPartnersFiltered"></natsal-chart>

                         <natsal-chart title="How often do people in Britain have sex?" 
                                     description="<h5>What does this chart show?</h5><p>The chart shows the distribution of numbers of occasions of sex that people living in Britain aged 16 to 74 are thought to have in the past 4 weeks as estimated from Natsal-3. It combines responses from the following two questions.</p><strong>Which Natsal-3 questions does it relate to?</strong><br/>
                                    <p>On how many occasions in the last 4 weeks have you had sex with a woman?<br/>On how many occasions in the last 4 weeks have you had sex with a man?</p>"
                                    chartId="sexual-frequency-comp"
                                    :originalData="originalDataSets.sexualFrequencyData"
                                    :filteredData="filteredDataSets.sexualFrequencyData"
                                    :categories="['0', '1-2', '3-5', '6+']"
                                    graphModalId="#graph3modal"
                                    :originalDataCount="originalDataCount"
                                    hasMedian="true"
                                    :noAnswer="noAnswerTotals.NumberOfSexActs"
                                    :noAnswerFiltered="noAnswerTotals.NumberOfSexActsFiltered"
                                    xAxisTitle="Number of occasions in the past 4 weeks"
                                    :customMedianIQR="customMedianIQR.NumberOfSexActs"
                                    :customMedianIQRFiltered="customMedianIQR.NumberOfSexActsFiltered"></natsal-chart>

                        <natsal-chart title="How recently have people in Britain had penis-in-vagina sex?" 
                                    description="<h5>What does this chart show?</h5><p>This chart shows the distribution of how recently people living in Britain aged 16 to 74 are thought to have had penis-in-vagina sex as estimated from Natsal-3.</p><strong>Which Natsal-3 questions does it relate to?</strong><br/>
                                    <p>When, if ever, was the last occasion you had vaginal sexual intercourse with a woman*? Vaginal sexual intercourse is defined as a man's penis in a woman's vagina.</p>
                                    <p>* if the participant is a man, else 'man' if the participant is a woman.</p>"
                                    chartId="sexual-experience-1-comp"
                                    :originalData="originalDataSets.lastPIVIntercourse"
                                    :filteredData="filteredDataSets.lastPIVIntercourse"
                                    :categories="['Last 7 Days',['1 & 4', 'weeks'], ['between 4 weeks', 'and 1 year'], ['More than', '1 year'], 'Never']"
                                    graphModalId="#graph4modal"
                                    :originalDataCount="originalDataCount"
                                    hasMedian="false"
                                    :noAnswer="noAnswerTotals.LastPenisVaginaAct"
                                    :noAnswerFiltered="noAnswerTotals.LastPenisVaginaActFiltered"
                                    xAxisTitle="Last occasion of penis-in-vagina sex"></natsal-chart>

                        <natsal-chart title="How common is ever experiencing anal sex with someone of the opposite-sex? " 
                                    description="<h5>What does this chart show?</h5><p>This chart shows the percentage of people living in Britain aged 16 to 74 who are thought to have ever had anal sex with someone of the opposite sex as estimated from Natsal-3.</p><strong>Which Natsal-3 questions does it relate to?</strong><br/>
                                    <p>When, if ever, was the last occasion you had anal sex with a woman*?’ Anal sex is defined as a man's penis in a partner's anus (rectum or back passage).</p>
                                    <p>* if the participant is a man, else 'man' if the participant is a woman.<br/>Note that responses for this chart have been categorised to either 'no, never' or 'yes, at least once'.</p>"
                                    chartId="sexual-experience-2-comp"
                                    :originalData="originalDataSets.hetAnal"
                                    :filteredData="filteredDataSets.hetAnal"
                                    :categories="['No, never', 'Yes, at least once']"
                                    graphModalId="#graph5modal"
                                    :originalDataCount="originalDataCount"
                                    hasMedian="false"
                                    :noAnswer="noAnswerTotals.HadAnalSex"
                                    :noAnswerFiltered="noAnswerTotals.HadAnalSexFiltered"
                                    xAxisTitle="Ever experienced anal sex with someone of the opposite-sex"></natsal-chart> 

                         <natsal-chart title="How common is same-sex sex?" 
                                    description="<h5>What does this chart show?</h5><p>This chart shows the percentage of people living in Britain aged 16 to 74 who are thought to have ever had same-sex sex as estimated from Natsal-3. </p><strong>Which Natsal-3 questions does it relate to?</strong><br/>
                                    <p>Have you had sex with a man* involving (genital area/vaginal/penis) contact?</p>
                                    <p>* if the participant is a man, else 'woman' if the participant is a woman.</p>"
                                    chartId="sexual-experience-3-comp"
                                    :originalData="originalDataSets.sameSex"
                                    :filteredData="filteredDataSets.sameSex"
                                    :categories="['No', 'Yes']"
                                    graphModalId="#graph6modal"
                                    :originalDataCount="originalDataCount"
                                    hasMedian="false"
                                    :noAnswer="noAnswerTotals.HadSameSex"
                                    :noAnswerFiltered="noAnswerTotals.HadSameSexFiltered"
                                    xAxisTitle="Ever experienced same-sex sex"></natsal-chart>

                        <natsal-chart title="What do people in Britain think about 'one night stands'?" 
                                    description="<h5>What does this chart show?</h5><p>This chart shows the distribution of opinions about one night stands for people living in Britain aged 16 to 74 as estimated from Natsal-3.</p><strong>Which Natsal-3 questions does it relate to?</strong><br/>
                                    <p>What is your opinion about a person having 'one night stands'?</p>"
                                    chartId="attitudes-1-comp"
                                    :originalData="originalDataSets.oneNightStand"
                                    :filteredData="filteredDataSets.oneNightStand"
                                    :categories="['Always wrong', ['Mostly/sometimes wrong', '(and ‘it depends’)'], ['Rarely wrong', 'if at all']]"
                                    graphModalId="#graph7modal"
                                    :originalDataCount="originalDataCount"
                                    hasMedian="false"
                                    :noAnswer="noAnswerTotals.OneNightStand"
                                    :noAnswerFiltered="noAnswerTotals.OneNightStandFiltered"
                                    xAxisTitle="Opinion of ‘one night stands’"></natsal-chart>

                        <natsal-chart title="What do people in Britain think about ‘extra-marital sex’?" 
                                   description="<h5>What does this chart show?</h5><p>This chart shows the distribution of opinions about 'extra-marital sex' among people living in Britain aged 16 to 74 as estimated from Natsal-3.</p><strong>Which Natsal-3 questions does it relate to?</strong><br/>
                                    <p>What is your opinion about a married person having sexual relations with someone other than his or her partner?</p>"
                                    chartId="attitudes-2-comp"
                                    :originalData="originalDataSets.extraMarital"
                                    :filteredData="filteredDataSets.extraMarital"
                                    :categories="['Always wrong', ['Mostly/sometimes wrong', '(and ‘it depends’)'], ['Rarely wrong', 'if at all']]"
                                    graphModalId="#graph8modal"
                                    :originalDataCount="originalDataCount"
                                    hasMedian="false"
                                    :noAnswer="noAnswerTotals.OtherPartnersMarried"
                                    :noAnswerFiltered="noAnswerTotals.OtherPartnersMarriedFiltered"
                                    xAxisTitle="Opinion of ‘extra-marital sex’"></natsal-chart>

                        <natsal-chart title="What do people in Britain think about sex between women?" 
                                    description="<h5>What does this chart show?</h5><p>This chart shows the distribution of opinions about sex between women among people living in Britain aged 16 to 74 as estimated from Natsal-3.</p><strong>Which Natsal-3 questions does it relate to?</strong><br/>
                                    <p>What is your general opinion about sexual relations between two adult women?</p>"
                                    chartId="norms-2-comp"
                                    :originalData="originalDataSets.sexBetweenWomen"
                                    :filteredData="filteredDataSets.sexBetweenWomen"
                                    :categories="['Always wrong', ['Mostly/sometimes wrong', '(and ‘it depends’)'], ['Rarely wrong', 'if at all']]"
                                    graphModalId="#graph9modal"
                                    :originalDataCount="originalDataCount"
                                    hasMedian="false"
                                    :noAnswer="noAnswerTotals.SameSexFemale"
                                    :noAnswerFiltered="noAnswerTotals.SameSexFemaleFiltered"
                                    xAxisTitle="Opinion of sex between women"></natsal-chart>  

                      
                        <natsal-chart title="What do people in Britain think about sex between men?" 
                                    description="<h5>What does this chart show?</h5><p>This chart shows the distribution of opinions about sex between men among people living in Britain aged 16 to 74 as estimated from Natsal-3.</p><strong>Which Natsal-3 questions does it relate to?</strong><br/>
                                    <p>What is your general opinion about sexual relations between two adult men?</p>"
                                    chartId="norms-1-comp"
                                    :originalData="originalDataSets.sexBetweenMen"
                                    :filteredData="filteredDataSets.sexBetweenMen"
                                    :categories="['Always wrong', ['Mostly/sometimes wrong', '(and ‘it depends’)'], ['Rarely wrong', 'if at all']]"
                                    graphModalId="#graph10modal"
                                    :originalDataCount="originalDataCount"
                                    hasMedian="false"
                                    :noAnswer="noAnswerTotals.SameSexMale"
                                    :noAnswerFiltered="noAnswerTotals.SameSexMaleFiltered"
                                    xAxisTitle="Opinion of sex between men"></natsal-chart>
                        
                        <natsal-chart title="How common is non-consensual sex?" 
                                    description="<h5>What does this chart show?</h5><p>This chart shows the percentage of people living in Britain aged 16 to 74 who are thought to have ever experienced non-consensual sex as estimated from Natsal-3. </p><strong>Which Natsal-3 questions does it relate to?</strong><br/>
                                    <p>Since the age of 13, has anyone made you have sex with them, against your will?</p>"
                                    chartId="age-first-sex-comp"
                                    :originalData="originalDataSets.nonConsentual"
                                    :filteredData="filteredDataSets.nonConsentual"
                                    :categories="['No', 'Yes']"
                                    graphModalId="#graph11modal"
                                    :originalDataCount="originalDataCount"
                                    hasMedian="false"
                                    :noAnswer="noAnswerTotals.SexAgainstWill"
                                    :noAnswerFiltered="noAnswerTotals.SexAgainstWillFiltered"
                                    xAxisTitle="Ever experienced non-consensual sex"></natsal-chart> 
                                                                                                                                                                                                            

                        <div class="col-md-6 column">

                            <div class="graph-panel graph-panel-4 sameHeight feedback-panel">

                                <div class="box-inner text-center">
                                <h2>What did you think of Sex Stats for the British population?</h2>
                                <h4>We would really appreciate your thoughts on it.</h4>
                                <a href="/form/feedback/" class="btn explore">Give feedback</a>

                                    
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

        </div>

        </div>
    </main>
</template>

<script>
import axios from 'axios';
import NatsalChart from './NatsalChart.vue';
import CryptoJS from 'crypto-js';

export default {
    components: {
        NatsalChart
    },
    data() {
        return {
            loading: false,
            data_list: [],
            filters: {
                sexuality: {
                    "hetero": false,
                    "nonhetero": false,
                },
                ageGroup: {
                    "young": false,
                    "middle": false,
                    "older": false
                },
                livingWithPartner: {
                    Yes: false,
                    No: false,
                },
                gender: {
                    male: false,
                    female: false,
                },
                parenting: {
                    nochildren: false,
                    child0to17: false,
                    child18plus: false
                },
            },
            originalDataSets: {
                sexualDebutData: [],
                sexualPartnersData: [],
                sexualFrequencyData: [],
                lastPIVIntercourse: [],
                hetAnal: [],
                sameSex: [],
                oneNightStand: [],
                extraMarital: [],
                sexBetweenWomen: [],
                sexBetweenMen: [],
                nonConsentual: []
            },
            filteredDataSets: {
                sexualDebutData: [],
                sexualPartnersData: [],
                sexualFrequencyData: [],
                lastPIVIntercourse: [],
                hetAnal: [],
                sameSex: [],
                oneNightStand: [],
                extraMarital: [],
                sexBetweenWomen: [],
                sexBetweenMen: [],
                nonConsentual: []
            },
            noAnswerTotals: {
                AgeFirstSex: 0,
                TotalPartners: 0,
                NumberOfSexActs: 0,
                LastPenisVaginaAct: 0,
                HadAnalSex: 0,
                HadSameSex: 0,
                OneNightStand: 0,
                OtherPartnersMarried: 0,
                SameSexFemale: 0,
                SameSexMale: 0,
                SexAgainstWill: 0,
                AgeFirstSexFiltered: 0,
                TotalPartnersFiltered: 0,
                NumberOfSexActsFiltered: 0,
                LastPenisVaginaActFiltered: 0,
                HadAnalSexFiltered: 0,
                HadSameSexFiltered: 0,
                OneNightStandFiltered: 0,
                OtherPartnersMarriedFiltered: 0,
                SameSexFemaleFiltered: 0,
                SameSexMaleFiltered: 0,
                SexAgainstWillFiltered: 0,
            },
            customMedianIQR: {
                TotalPartners: [],
                NumberOfSexActs: [],
                TotalPartnersFiltered: [],
                NumberOfSexActsFiltered: []
            },
            originalDataCount: 0,
            ShowShareLink: false,
            txtShareURL: window.location.href,
            AESPassphrase: "OpenUniversity"
        }
    },
    watch: {

    },
    methods: {
        FetchData() {
            let app = this;
            app.loading = true;
            var url = process.env.VUE_APP_API_URL;
            axios.get(url)
                .then(function (res) {
                    app.data_list = res.data.dataList;

                    app.originalDataCount = app.data_list.length;

                    // Save original data for stacked chart
                    var sexualDebutData = app.GetChartSeries(app.data_list, 'AgeFirstSex', 5, false);
                    app.originalDataSets.sexualDebutData = sexualDebutData;
                    
                    var sexualPartnersData = app.GetChartSeries(app.data_list, 'TotalPartners', 5, false);
                    app.originalDataSets.sexualPartnersData = sexualPartnersData;

                    var sexualFrequencyData = app.GetChartSeries(app.data_list, 'NumberOfSexActs', 4, false);
                    app.originalDataSets.sexualFrequencyData = sexualFrequencyData;

                    var lastPIVIntercourse = app.GetChartSeries(app.data_list, 'LastPenisVaginaAct', 5, false);
                    app.originalDataSets.lastPIVIntercourse = lastPIVIntercourse;

                    var hetAnal = app.GetChartSeries(app.data_list, 'HadAnalSex', 2, false);
                    app.originalDataSets.hetAnal = hetAnal;
                    
                    var sameSex = app.GetChartSeries(app.data_list, 'HadSameSex', 2, false);
                    app.originalDataSets.sameSex = sameSex;

                    var oneNightStand = app.GetChartSeries(app.data_list, 'OneNightStand', 3, false);
                    app.originalDataSets.oneNightStand = oneNightStand;

                    var extraMarital = app.GetChartSeries(app.data_list, 'OtherPartnersMarried', 3, false);
                    app.originalDataSets.extraMarital = extraMarital;

                    var sexBetweenWomen = app.GetChartSeries(app.data_list, 'SameSexFemale', 3, false);
                    app.originalDataSets.sexBetweenWomen = sexBetweenWomen;

                    var sexBetweenMen = app.GetChartSeries(app.data_list, 'SameSexMale', 3, false);
                    app.originalDataSets.sexBetweenMen = sexBetweenMen;

                    var nonConsentual = app.GetChartSeries(app.data_list, 'SexAgainstWill', 2, false);
                    app.originalDataSets.nonConsentual = nonConsentual;

                    app.loading = false;
                })
                .catch(function (res) {
                    console.log(res);
                    app.loading = false;
                });
        },
        ChangeFilter(category, item) {
            this.filters[category][item] = !this.filters[category][item];

            this.ShowShareLink = false;

            if (!this.allNotSelected) {
                // minify filters
                var str = "";

                if (this.filters.sexuality.hetero) { str += "1"; } 
                else { str += "0"; }

                if (this.filters.sexuality.nonhetero) { str += "1"; }
                else { str += "0"; }

                if (this.filters.ageGroup.young) { str += "1"; }
                else { str += "0"; }

                if (this.filters.ageGroup.middle) { str += "1"; }
                else { str += "0"; }

                if (this.filters.ageGroup.older) { str += "1"; }
                else { str += "0"; }

                if (this.filters.livingWithPartner.Yes) { str += "1"; }
                else { str += "0"; }

                if (this.filters.livingWithPartner.No) { str += "1"; }
                else { str += "0"; }

                if (this.filters.gender.male) { str += "1"; }
                else { str += "0"; }

                if (this.filters.gender.female) { str += "1"; }
                else { str += "0"; }

                if (this.filters.parenting.nochildren) { str += "1"; }
                else { str += "0"; }

                if (this.filters.parenting.child0to17) { str += "1"; }
                else { str += "0"; }

                if (this.filters.parenting.child18plus) { str += "1"; }
                else { str += "0"; }
                
                var filterObj = {
                    value: str
                };

                var filtersStr = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(filterObj), this.AESPassphrase));

                //var filtersStr = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(this.filters), this.AESPassphrase));

                this.txtShareURL = window.location.href + "?f=" + filtersStr;
            }
        },
        ResetFilters() {
            this.filters.sexuality.hetero = false;
            this.filters.sexuality.nonhetero = false;
            this.filters.ageGroup.young = false;
            this.filters.ageGroup.middle = false;
            this.filters.ageGroup.older = false;
            this.filters.livingWithPartner.Yes = false;
            this.filters.livingWithPartner.No = false;
            this.filters.gender.male = false;
            this.filters.gender.female = false;
            this.filters.parenting.nochildren = false;
            this.filters.parenting.child18plus = false;
            this.filters.parenting.child0to17 = false;
        },
        UpdateChartData(data) {
            if (this.allNotSelected) {
                this.filteredDataSets.sexualDebutData = [0, 0, 0, 0, 0];
                this.filteredDataSets.sexualPartnersData = [0, 0, 0, 0, 0];
                this.filteredDataSets.sexualFrequencyData = [0, 0, 0, 0];
                this.filteredDataSets.lastPIVIntercourse = [0, 0, 0, 0, 0];
                this.filteredDataSets.hetAnal = [0, 0];
                this.filteredDataSets.sameSex = [0, 0];
                this.filteredDataSets.oneNightStand = [0, 0, 0];
                this.filteredDataSets.extraMarital = [0, 0, 0];
                this.filteredDataSets.sexBetweenWomen = [0, 0, 0];
                this.filteredDataSets.sexBetweenMen = [0, 0, 0];
                this.filteredDataSets.nonConsentual = [0, 0];
            }
            else {
                // Sexual debut
                this.filteredDataSets.sexualDebutData = this.GetChartSeries(data, 'AgeFirstSex', 5, true);
            
                // Sexual partners
                this.filteredDataSets.sexualPartnersData = this.GetChartSeries(data, 'TotalPartners', 5, true);
            
                // Sexual frequency
                this.filteredDataSets.sexualFrequencyData = this.GetChartSeries(data, 'NumberOfSexActs', 4, true);
                        
                // Last PIV intercourse
                this.filteredDataSets.lastPIVIntercourse = this.GetChartSeries(data, 'LastPenisVaginaAct', 5, true);
                
                // Het anal
                this.filteredDataSets.hetAnal = this.GetChartSeries(data, 'HadAnalSex', 2, true);
                
                // Same sex
                this.filteredDataSets.sameSex = this.GetChartSeries(data, 'HadSameSex', 2, true);
                
                // One Night stand
                this.filteredDataSets.oneNightStand = this.GetChartSeries(data, 'OneNightStand', 3, true);
                
                // Extra Marital
                this.filteredDataSets.extraMarital = this.GetChartSeries(data, 'OtherPartnersMarried', 3, true);
                
                // Sex between women
                this.filteredDataSets.sexBetweenWomen = this.GetChartSeries(data, 'SameSexFemale', 3, true);
                
                // Sex between men
                this.filteredDataSets.sexBetweenMen = this.GetChartSeries(data, 'SameSexMale', 3, true);
                
                // Non consentual
                this.filteredDataSets.nonConsentual = this.GetChartSeries(data, 'SexAgainstWill', 2, true);
            }
        },
        GetChartSeries(data, attribute, defaultLength, filtered) {   
            var seriesCounts = data.reduce((prev, curr) => {
                var name = curr[attribute]; // Change this
                
                if (name != "") {
                    if (!Object.prototype.hasOwnProperty.call(prev, name)) {
                        prev[name] = 0;
                    }
                    prev[name] += Number(curr.Weight); // ++ for single row
                    return prev;
                }
                else {
                    if (!Object.prototype.hasOwnProperty.call(prev, name)) {
                        prev[name] = 0;
                    }
                    prev[name]++; // ++ for single row
                    return prev;
                }
               
            }, {});

            if (attribute == "TotalPartners" || attribute == "NumberOfSexActs") {
                this.customMedianIQR[attribute + 'Filtered'] = [];
                this.customMedianIQR[attribute] = [];

                let rawDataArray = [];

                for (var j = 0; j < data.length; j++) {
                    let tmpData = data[j][attribute + '_MedianIQR'];

                    if (tmpData != ''){
                        rawDataArray.push(tmpData);
                    }
                }

                // custom median/iqr
                
                //"TotalPartners_MedianIQR"
                //"NumberOfSexActs_MedianIQR"

                if (filtered) {
                    this.customMedianIQR[attribute + 'Filtered'] = rawDataArray;
                }
                else {
                    this.customMedianIQR[attribute] = rawDataArray;
                }
            }

            if (Object.prototype.hasOwnProperty.call(seriesCounts, "")) {
                if (filtered) {
                    this.noAnswerTotals[attribute + 'Filtered'] = seriesCounts[""];
                }
                else {
                    this.noAnswerTotals[attribute] = seriesCounts[""];  
                }
                
                delete seriesCounts[""];
            }

            var seriesData = Object.keys(seriesCounts).map(k => {
                return Math.round(seriesCounts[k]);
            });
            
            if (seriesData.length == 0) {
                seriesData = [];
                for (var i = 0; i < defaultLength; i++)
                seriesData.push(0);
            }

            return seriesData;
        },
        GetStackedSet(originalData, currentData) {
            var newSet = [];
            for (var i = 0; i < originalData.length; i++) {
                var originalVal = 0;
                var currentVal = 0;

                if (currentData.length > i) {
                    currentVal = currentData[i];
                }

                if (originalData.length > i) {
                    originalVal = originalData[i];
                }
                newSet.push(originalVal - currentVal);
            }

            return newSet;
        },
    },
    computed: {
        itemsFiltered() {
            if (this.allNotSelected) {
                this.UpdateChartData(this.data_list);
                return this.data_list;
            }
            else {
                var data = this.data_list.filter(obj =>
                    (this.sexualityNotSelected
                        || (this.filters["sexuality"]["hetero"] && obj.Sexuality == "1")
                        || (this.filters["sexuality"]["nonhetero"] && obj.Sexuality == "0"))
                    && (this.ageGroupNotSelected
                        || ((this.filters["ageGroup"]["young"] && obj.AgeGroup3Group == "1")
                            || (this.filters["ageGroup"]["middle"] && obj.AgeGroup3Group == "2")
                            || (this.filters["ageGroup"]["older"] && obj.AgeGroup3Group == "3")))
                    && (this.livingWithPartnerNotSelected
                        || (this.filters["livingWithPartner"]["Yes"] && obj.LiveWithPartner == "1")
                        || (this.filters["livingWithPartner"]["No"] && obj.LiveWithPartner == "0"))
                    && (this.genderNotSelected
                        || ((this.filters["gender"]["male"] && obj.Gender == "0")
                            || (this.filters["gender"]["female"] && obj.Gender == "1")))
                    && (this.parentingNotSelected
                        || ((this.filters["parenting"]["nochildren"] && obj.NoChildren == "1")
                            || (this.filters["parenting"]["child0to17"] && obj.Child0To17 == "1")
                            || (this.filters["parenting"]["child18plus"] && obj.Child18Plus == "1")))
                );

                this.UpdateChartData(data);
               
                // Return
                return data;
            }
        },
        allNotSelected() {
            return !this.filters.sexuality.hetero
                && !this.filters.sexuality.nonhetero
                && !this.filters.ageGroup.young
                && !this.filters.ageGroup.middle
                && !this.filters.ageGroup.older
                && !this.filters.livingWithPartner.Yes
                && !this.filters.livingWithPartner.No
                && !this.filters.gender.male
                && !this.filters.gender.female
                && !this.filters.parenting.nochildren
                && !this.filters.parenting.child0to17
                && !this.filters.parenting.child18plus
        },
        sexualityNotSelected() {
            return !this.filters.sexuality.hetero && !this.filters.sexuality.nonhetero;
        },
        ageGroupNotSelected() {
            return !this.filters.ageGroup.young
                && !this.filters.ageGroup.middle
                && !this.filters.ageGroup.older;
        },
        livingWithPartnerNotSelected() {
            return !this.filters.livingWithPartner.Yes && !this.filters.livingWithPartner.No;
        },
        genderNotSelected() {
            return !this.filters.gender.male
                && !this.filters.gender.female;
        },
        parentingNotSelected() {
            return !this.filters.parenting.nochildren //!this.filters.parenting.child0to4
                && !this.filters.parenting.child0to17
                && !this.filters.parenting.child18plus;
        }
    },
    created: function () {
        var urlParams = new URLSearchParams(window.location.search);
        var filterQueryString = urlParams.get('f');
        
        if (filterQueryString) {
            var filtersStr = CryptoJS.AES.decrypt(decodeURIComponent(filterQueryString), this.AESPassphrase).toString(CryptoJS.enc.Utf8);
            var filtersObj = JSON.parse(filtersStr);

            console.log(filtersObj);

            for (var i = 0; i < filtersObj.value.length; i++) {
                switch (i) {
                    case 0:
                        this.filters.sexuality.hetero = filtersObj.value[i] == "1";
                        break;
                    case 1:
                        this.filters.sexuality.nonhetero = filtersObj.value[i] == "1";
                        break;
                    case 2:
                        this.filters.ageGroup.young = filtersObj.value[i] == "1";
                        break;
                    case 3:
                        this.filters.ageGroup.middle = filtersObj.value[i] == "1";
                        break;
                    case 4:
                        this.filters.ageGroup.older = filtersObj.value[i] == "1";
                        break;
                    case 5:
                        this.filters.livingWithPartner.Yes = filtersObj.value[i] == "1";
                        break;
                    case 6:
                        this.filters.livingWithPartner.No = filtersObj.value[i] == "1";
                        break;
                    case 7:
                        this.filters.gender.male = filtersObj.value[i] == "1";
                        break;
                    case 8:
                        this.filters.gender.female = filtersObj.value[i] == "1";
                        break;
                    case 9:
                        this.filters.parenting.nochildren = filtersObj.value[i] == "1";
                        break;
                    case 10:
                        this.filters.parenting.child0to17 = filtersObj.value[i] == "1";
                        break;
                    case 11:
                        this.filters.parenting.child18plus = filtersObj.value[i] == "1";
                        break;

                }
            }
            // Decrypt filters string

            //this.filters = JSON.parse(filtersStr);
            this.txtShareURL = window.location.href + "?f=" + filtersStr;
        }
    },
    mounted: function () {
        this.FetchData();
    }
}
</script>
